export enum OnlineView {
    UNKNOWN = 0,
    HAS_ANY = 1
}
